// Family tutorial. Four screens, phone-first.
//
// The audience is a daughter or son, usually remote, usually anxious, opening this for the
// first time after their parent moved into a building they do not run. Two constraints shape
// everything here:
//
//  1. They have no authority and should not be told they do. Consent belongs to the resident,
//     access is granted rather than claimed, and every screen has to be honest that the answer
//     to "can I see that" is often no.
//  2. The instinct to reassure is the trap. A family member reading cheerful copy about a
//     parent's decline stops trusting the product. Plain, adult, specific.
window.FAMILY_TUTORIAL = {
  role: 'Family',
  lead: 'Four things worth knowing.',

  screens: [
    {
      id: 'what',
      n: '1',
      title: 'What you can see',
      body: 'You see what your relative has agreed to share, and nothing else. Not their full medical record, not staff notes, and not the raw text of their conversations.',
      points: [
        'How they are doing, day to day.',
        'Their mood over the last two weeks.',
        'Anything the building told you about, and when.',
      ],
      note: 'If something you expected is missing, it has not been shared with you rather than hidden from you. Ask them, or ask the building.',
    },
    {
      id: 'consent',
      n: '2',
      title: 'It is their decision, not yours',
      body: 'Every kind of sharing starts switched off. Your relative turns on what they want you to see, and they can turn it off again at any time without telling you first.',
      points: [
        'They can share some things and not others.',
        'They can change their mind, and it takes effect immediately.',
        'You will not be notified when they do.',
      ],
      note: 'Where somebody cannot make that decision themselves, their legal representative makes it. That is a formal role, and being the closest relative is not the same thing.',
    },
    {
      id: 'told',
      n: '3',
      title: 'When you will hear from us',
      body: 'You are told when something happens that a family member should know about. A serious change in how they are, a fall, a transfer to hospital. You are not told about every quiet day.',
      points: [
        'A person decides what reaches you, not a machine.',
        'Every notice says what happened, when, and who was told.',
        'Silence means nothing has met that bar, not that nobody is looking.',
      ],
      note: 'In an emergency the building calls you. This is a record of what you were told, not the way you find out.',
    },
    {
      id: 'not',
      n: '4',
      title: 'What this is not',
      body: 'It is a window, not a way in. You cannot direct their care through it or change their medication. A request you send goes to the care team as a family request, not an alert.',
      points: [
        'Care decisions stay with the clinical team and your relative.',
        'To raise something, message the care team in the Family Portal, or contact the building.',
        'A number here is a prompt to ask a question, never a diagnosis.',
      ],
      note: 'If you are worried about how your relative is being treated, say so to the administrator. You do not need evidence from this page first, and raising a concern in good faith is protected.',
    },
  ],

  end: {
    title: 'That is everything',
    lines: [
      'Check in when you want to. Nothing here needs managing.',
      'What you see may change, because what they share is theirs to choose.',
    ],
    ask: 'For anything about their care, message the care team or contact the building. For anything about this page, ask them to check their sharing settings.',
    cta: 'See how they are',
  },
};
